import { css, html } from "lit";
import { queryAssignedElements, state } from "lit/decorators.js";
import "../../atom/Row/index.js";
import "../../atom/Column/index.js";
import "../IconButton/index.js";
import "../Popover/index.js";
import "../Badge/index.js";
import "../Link/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { ICON_NAMES } from "../../atom/Icon/lucideIconNames.js";
import { rif } from "../../../helpers/renderIf.js";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfNotification = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_icon = "Info";
    this.dsf_icon_level = "attention";
    this.dsf_unread = false;
    this._hasActions = false;
  }
  handleActionsSlotChange() {
    this._hasActions = this.actionSlot && this.actionSlot.length > 0 || false;
  }
  ctaLinkClick() {
    this.emit("call-to-action");
  }
  renderActions() {
    if (this._hasActions) {
      return html`<dsf-popover
        dsf_offset_vertical="0"
        dsf_hide_arrow
        @click=${(event) => event.stopPropagation()}
        dsf_accessibility_label="Notification actions"
      >
        <dsf-icon-button
          slot="anchor"
          dsf_icon="MoreVertical"
          dsf_size="small"
          dsf_title="Notification actions"
        >
        </dsf-icon-button>
        <slot name="actions" @slotchange=${this.handleActionsSlotChange}></slot>
      </dsf-popover>`;
    }
    return html`<slot name="actions" @slotchange=${this.handleActionsSlotChange}></slot>`;
  }
  render() {
    const badgeClasses = ["mt-4"];
    if (this.dsf_unread) {
      badgeClasses.push("unread");
    }
    return html`
      <div
        class="flex w-full cursor-pointer flex-col border-b-1 border-neutral-100 bg-neutral-0 p-8 pl-12 pt-16 hover:bg-neutral-50"
        data-skeleton
      >
        <dsf-row dsf_align="top" dsf_gap="m">
          <!-- Notification -->
          <dsf-badge
            dsf_icon_left="${this.dsf_icon}"
            dsf_level="${this.dsf_icon_level}"
            class=${concatClasses(badgeClasses)}
          ></dsf-badge>
          <!-- Left column  -->
          <dsf-col class="gap-2">
            <span class="dsf-text-xxs-semibold">${this.dsf_title}</span>
            <div class="dsf-text-xxs text-pretty text-neutral-400"><slot></slot></div>
          </dsf-col>
          <!-- Right column  -->
          <dsf-col class="items-end" dsf_justify="space-between" dsf_basis="content">
            ${this.renderActions()}
          </dsf-col>
        </dsf-row>
        <!-- Call to action, timestamp -->
        <dsf-row class="mt-4 flex items-center gap-8 pl-36">
          ${rif(
      this.dsf_call_to_action,
      html`<dsf-link dsf_size="small" class="max-w-fit" @click=${this.ctaLinkClick}>
              ${this.dsf_call_to_action}
            </dsf-link>`
    )}
          <div class="dsf-text-xxs ml-auto whitespace-nowrap text-neutral-300">
            ${this.dsf_timestamp}
          </div>
        </dsf-row>
      </div>
    `;
  }
};
DsfNotification.styles = [
  ...BaseComponent.styles,
  css`
      dsf-popover::part(dropdown) {
        border-color: rgb(var(--dsf-color-neutral-100));
      }

      .unread {
        position: relative;
      }

      .unread::after {
        position: absolute;
        content: '';
        top: calc(-0.6 * var(--dsf-base-size));
        right: calc(-0.6 * var(--dsf-base-size));
        background: rgb(var(--dsf-color-secondary-300));
        width: calc(0.6 * var(--dsf-base-size));
        height: calc(0.6 * var(--dsf-base-size));
        border-radius: 50%;
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfNotification.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: ICON_NAMES, reflect: true })
], DsfNotification.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: String })
], DsfNotification.prototype, "dsf_icon_level", 2);
__decorateClass([
  prop({ type: String })
], DsfNotification.prototype, "dsf_timestamp", 2);
__decorateClass([
  prop({ type: String })
], DsfNotification.prototype, "dsf_call_to_action", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfNotification.prototype, "dsf_unread", 2);
__decorateClass([
  queryAssignedElements({ flatten: true, slot: "actions" })
], DsfNotification.prototype, "actionSlot", 2);
__decorateClass([
  state()
], DsfNotification.prototype, "_hasActions", 2);
DsfNotification = __decorateClass([
  defineElement("dsf-notification")
], DsfNotification);
export {
  DsfNotification
};
